import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Row,
  Col,
  message,
  Tooltip,
  Modal,
  Form,
  Input,
  Button,
  notification,
  Popconfirm,
} from "antd";
import {
  BarsOutlined,
  RollbackOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  MailOutlined,
  MailFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import CurrencyFormat from "react-currency-format";
import { useHistory } from "react-router-dom";
import config from "../../util/ApiforContext";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import Iframe from "react-iframe";
import { isEmpty, values } from "lodash";
import { useMediaQuery } from "react-responsive";
import FirmTrackingSendMailForm from "../Forms/FirmTrackingSendMailForm";
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};

const AccountPage = (props) => {
  const [firmMonthlyStatusReport, setFirmMonthlyStatusReport] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [skip, setSkip] = useState(0);
  const [query, setQuery] = useState("");
  const [currencyString, setCurrencyString] = useState("");
  const [dataState, setDataState] = useState({ skip: 0, take: 20 });
  const [firmName, setFirmName] = useState("");
  const [firmId, setFirmId] = useState(props.match.params.firmid);
  const [TransactionDate, setTransactionDate] = useState(
    props.match.params.transactionDate
  );
  const [TransactionDate2, setTransactionDate2] = useState(
    props.match.params.transactionDate2
  );
  const [Currency, setCurrency] = useState(props.match.params.currency);
  const [balanceDate, setBalanceDate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [pdfUrl, setPdfUrl] = useState("");
  const [Email, setEmail] = useState("");
  const [EmailVisible, setEmailVisible] = useState(true);
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accountIdForModalReceipt, setAccountIdForModalReceipt] = useState("");
  const [firmValues, SetFirmValues] = useState(JSON);
  const [sendFirmTrackingMail, setsendFirmTrackingMail] = useState({
    visible: false,
    data: null,
  });

  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  useEffect(() => {
    setFirmMonthlyStatusReport({
      ...firmMonthlyStatusReport,
      loading: true,
    });
    RequestHandler.post(
      `/Reports/GetMonthlyCollectionStatusReport`,
      {
        FirmId: firmId,
        Date:
          TransactionDate === "" || TransactionDate == "null"
            ? null
            : TransactionDate,
        EndDate:
          TransactionDate2 === "" || TransactionDate2 == "null"
            ? null
            : TransactionDate2,
        CurrencyCode: Currency === "" ? null : Currency,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.data.length > 0) {
        setCurrencyString(" TRY");
        setTotalAmount(res.data.at(-1).dateTimeNowBalance);
        setBalanceDate(
          moment(
            res.data.at(-2).transactionDate.split("/")[0] +
            (res.data.at(-2).transactionDate.split("/")[1].length > 1
              ? res.data.at(-2).transactionDate.split("/")[1]
              : "0" + res.data.at(-2).transactionDate.split("/")[1]) +
            "13"
          ).format("MMMM YYYY") + " -"
        );
        setFirmMonthlyStatusReport({
          data: res.data,
          total: res.data["@odata.count"],
          loading: false,
        });
        setFirmName(res.data[0].collectPlanTransactionReportVms[0].firmName);
      } else {
        setFirmMonthlyStatusReport({
          data: [],
          total: 0,
          loading: false,
        });
      }
    });
  }, [setDataState, skip, setSkip, query, setQuery, setFirmId]);

  useEffect(() => {
    RequestHandler.get(`/Firm/GetById/${firmId}`, undefined, {
      rawResponse: true,
    }).then((response) => {
      if (response.status == 200) {
        setEmail(response.data.email);
        SetFirmValues(response.data);
      }
    });
  }, [props]);

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "center",
      style: "color:green",
      width: "25%",
      render: (text, record) => {
        return (
          <p style={{ fontWeight: "700" }}>
            {text == "Toplam"
              ? " Toplam "
              : moment(
                text.split("/")[0] +
                (text.split("/")[1].length > 1
                  ? text.split("/")[1]
                  : "0" + text.split("/")[1]) +
                "13"
              ).format("MMM YYYY")}
          </p>
        );
      },
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlanTotal",
      key: "collectPlanTotal",
      align: "center",
      width: "25%",
      render: renderDecimal,
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "collectTotal",
      key: "collectTotal",
      align: "center",
      width: "25%",
      render: renderDecimal,
    },
    {
      title: "Bakiye",
      dataIndex: "balance",
      key: "balance",
      align: "center",
      width: "25%",
      render: renderDecimal,
    },
  ];

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    RequestHandler.post(
      `/Reports/GetMonthlyCollectionStatusPlanForExcel`,
      {
        FirmId: firmId,
        Date:
          TransactionDate === "" || TransactionDate == "null"
            ? null
            : TransactionDate,
        EndDate:
          TransactionDate2 === "" || TransactionDate2 == "null"
            ? null
            : TransactionDate2,
        CurrencyCode: Currency === "" ? null : Currency,
      },
      false
    ).then((response) => {
      hideMessage();
      if (response) {
        window.open(
          `${config.apiUrl
          }/Reports/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const showModalReceipt = (value) => {
    setAccountIdForModalReceipt(value);
    setEmailVisible(true);

    RequestHandler.get(
      `/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${value}&isDownload=false`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      if (response.status == 200) {
        setPdfUrl(response.data);
        setIsModalVisible(true);
      }
    });
  };
  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const handleCancelReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const onFinishUpdateReceipt = (values) => { };
  const onFinishFailedUpdateReceipt = (values) => { };

  const sendSuccessMail = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Mail gönderme işlemi başarılı.",
      duration: 2,
    });
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/Reports/ReceiptSendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "Error") {
          mailNotFound("error");
        } else if (res.status == 204 || res.status == 200) {
          updateFirmMail();
          sendSuccessMail("success");
        }
        setLoading(false);
        setIsModalVisible(false);
      });
    } else {
      mailEmptyError("error");
      setLoading(false);
    }
  };

  const updateFirmMail = () => {
    if (Email.length > 0 && firmValues.email == "") {
      RequestHandler.put(
        `/Firm`,
        {
          id: firmValues.id,
          email: Email,
          name: firmValues.name,
          firmBranchNumber: firmValues.firmBranchNumber,
        },
        false,
        { rawResponse: true }
      ).then((res) => { });
    }
  };

  const mailEmptyError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Mail adresi girilmedi.",
      duration: 2,
    });
  };
  const mailNotFound = (type) => {
    notification[type]({
      message: "HATA",
      description: "Mail adresi kayıtlı değil.",
      duration: 2,
    });
  };
  const alertSuccess = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Pdf indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };
  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };

  const downloadPdf = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    window.open(
      `${config.apiUrl
      }/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${accountIdForModalReceipt}&isDownload=true&t=${RequestHandler.getToken()}`
    );
    setIsModalVisible(true);
    alertSuccess("success");
    hide();
  };

  const onSendFirmTrackingMail = (values) => {
    setsendFirmTrackingMail({
      visible: true,
      data: {
        firmId: props.match.params.firmid,
        email: Email,
        transactionId: values.transactionId,
        planId: values.planId,
        currencyCode: props.match.params.currency,
      },
    });
  };
  const expandedRowRender = (data) => {
    const columns = [
      {
        title: "Tarih",
        dataIndex: "transactionDate",
        key: "transactionDate",
        width: "17%",
      },
      {
        title: "İşlem Tipi",
        dataIndex: "processTypeName",
        key: "processTypeName",
        width: "17%",
      },
      {
        title: "Plan",
        dataIndex: "collectPlanTotal",
        key: "collectPlanTotal",
        width: "17%",
        render: renderDecimal,
      },
      {
        title: "Gelen",
        dataIndex: "collectTotal",
        key: "collectTotal",
        width: "17%",
        render: renderDecimal,
      },
      {
        title: "Bakiye",
        dataIndex: "balance",
        key: "balance",
        width: "17%",
        render: renderDecimal,
      },
      {
        title: "Dekont",
        dataIndex: "operation",
        width: "6%",
        align: "center",
        render: (data, record) => {
          return (
            <a
              hidden={record.collectPlanTotal > 0}
              style={{ color: "black", fontSize: "130%" }}
              onClick={() => showModalReceipt(record.transactionId)}
            >
              {" "}
              <FilePdfOutlined />
            </a>
          );
        },
      },
      {
        title: "Mail Gönder",
        dataIndex: "operation",
        width: "9%",
        align: "center",
        render: (data, record) => {
          return (
            <div>
              <Popconfirm
                title="Fatura Detay maili göndermek istediğinize emin misiniz?"
                onConfirm={() => {
                  onSendFirmTrackingMail(record);
                }}
                okText="Evet"
                cancelText="İptal"
              >
                <a>
                  <MailOutlined style={{ fontSize: "130%" }} />
                </a>
              </Popconfirm>
            </div>
          );
        },
      },
    ];

    return (
      <Table
        columns={columns}
        size="small"
        dataSource={data}
        pagination={false}
      />
    );
  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={(e) => history.goBack(e)}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={20}>
          <p style={{ fontSize: "120%", marginLeft: 13 }}>
            <BarsOutlined /> AYLIK TAHSİLAT RAPORU
          </p>
        </Col>
        <Col
          xs={24}
          md={12}
          lg={4}
          style={{ textAlign: "right" }}
          hidden={firmMonthlyStatusReport.data.length > 0 ? false : true}
        >
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col span={12} style={{ textAlign: "start", fontSize: 19 }}>
          <p>{firmName}</p>
        </Col>
        <Col span={12} style={{ textAlign: "end", fontSize: 19 }}>
          {balanceDate} Cari Bakiye :{" "}
          <CurrencyFormat
            value={parseFloat(totalAmount)}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
          />
          {Currency == "null" ? currencyString : " " + Currency}
        </Col>
      </Row>

      <Table
        columns={columns}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Veri Yok"
            />
          ),
        }}
        expandable={{
          expandedRowRender: (record) =>
            expandedRowRender(record.collectPlanTransactionReportVms),
          rowExpandable: (record) =>
            record.collectPlanTransactionReportVms !== null,
        }}
        style={{ overflowX: "auto", maxHeight: "100%", tableLayout: "unset" }}
        size="small"
        rowKey="transactionDate"
        sortable={true}
        dataSource={firmMonthlyStatusReport.data}
        loading={firmMonthlyStatusReport.loading}
        pagination={false}
      />

      {isDesktopOrLaptop ? (
        <Modal
          title="Dekont"
          width={1000}
          style={{ height: 1000 }}
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateReceipt}
            onFinishFailed={onFinishFailedUpdateReceipt}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={20}></Col>
              <Col span={2}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={2}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => downloadPdf()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={18}>
                <Form.Item
                  label="Mail Adresi"
                  name="Email"
                  style={{ width: "100%" }}
                  rules={[{ type: "email" }]}
                >
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    Gönder
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            key={0}
            src={`${pdfUrl}`}
            width="100%"
            height="1000px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      ) : (
        <Modal
          title="Dekont"
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishUpdateReceipt}
            onFinishFailed={onFinishFailedUpdateReceipt}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={14}></Col>
              <Col span={5}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={5}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => downloadPdf()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={18}>
                <Form.Item
                  label=""
                  name="Email"
                  style={{ width: "200%" }}
                  rules={[{ type: "email" }]}
                >
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    Gönder
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            key={1}
            src={`${pdfUrl}`}
            width="100%"
            height="400px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      )}
      <Modal
        id="sendFirmMail"
        centered
        visible={sendFirmTrackingMail.visible}
        onCancel={() => setsendFirmTrackingMail({ visible: false, data: null })}
        footer={null}
      >
        <FirmTrackingSendMailForm
          data={sendFirmTrackingMail.data}
          onFinish={() =>
            setsendFirmTrackingMail({ visible: false, data: null })
          }
        />
      </Modal>
    </div>
  );
};

export default AccountPage;
